/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

'use strict';

const intelligentFormatObj = require('dibs-currency-helpers/intelligentFormatObj');

module.exports = {
    /**
     *
     * @param {object} copy
     * @param {boolean} isSoldIndividually
     * @param {number|string} price
     * @param {string} currency
     * @returns {{string, abbreviation, perItem: string}}
     */
    formatPrice({ copy = {}, isSoldIndividually, price, currency }) {
        const priceStates = copy.priceStates || {};
        const perItemCopy = priceStates.perItem
            ? priceStates.perItem
            : copy['cart.priceStates.perItem'];
        const { sign, currencySymbol, number, abbreviation } = intelligentFormatObj(
            price,
            currency
        );
        const string = `${sign} ${currencySymbol}${number}`.trim();
        let perItem = '';

        if (isSoldIndividually) {
            perItem += ` ${perItemCopy}`;
        }

        return {
            string,
            abbreviation,
            perItem,
        };
    },
};



// WEBPACK FOOTER //
// ./assets/js/components/Price/helpers.es.js